import React from "react";
import CategoryIcon from "@mui/icons-material/Category";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

export type NavigationIcons = Record<string, JSX.Element>;

const navigationIcon: NavigationIcons = {
  andqoHome: <AssignmentRoundedIcon />,
  andqoCategory: <CategoryIcon />,
  sncfHome: <AssignmentRoundedIcon />,
  sncfStatus: <ConfirmationNumberIcon />,
};

export default navigationIcon;
